<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <slick v-bem.steps ref="steps" :options="stepsOptions" @afterChange="sync">
      <div v-for="(step, index) in steps" :key="'item_'+index" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
        <div class="row equal-height reorder">
          <div class="col-4 col-t-5 second">
            <div class="content">
              <p v-bem.steps:number>{{index+1}}</p>
              <div v-html="$t(`carousel.item${index+1}`)"></div>
            </div>
          </div>
          <div class="col-8 col-t-7 first desktop" v-bem.steps:image :style="{ backgroundImage: `url(${step.background})` }"></div>
          <div class="col-8 col-t-7 first mobile" v-bem.steps:image :style="{ backgroundImage: `url(${step.background_m})` }"></div>
        </div>
      </div>
    </slick>
    <slick v-bem.nav="{rtl: $i18n.locale === 'ar'}" ref="nav" :options="navOptions">
      <template v-for="(item, index) in steps">
        <div :key="index" v-bem:item="{ active: current === index}" @click="goTo(index)">
          <img :src="item.icon" :alt="$t(`carousel.label${index+1}`)">
          <p :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">{{$t(`carousel.label${index+1}`)}}</p>
        </div>
      </template>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'Carousel',
  components: {
    Slick
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          icon        : require('@/assets/img/icons/cars.svg'),
          background  : require('@/assets/img/steps/1.jpg'),
          background_m: require('@/assets/img/steps/1-m.jpg')
        },
        {
          icon        : require('@/assets/img/icons/calc.svg'),
          background  : require('@/assets/img/steps/2.jpg'),
          background_m: require('@/assets/img/steps/2-m.jpg')
        },
        {
          icon        : require('@/assets/img/icons/folder.svg'),
          background  : require('@/assets/img/steps/3.jpg'),
          background_m: require('@/assets/img/steps/3-m.jpg')
        },
        {
          icon        : require('@/assets/img/icons/garage.svg'),
          background  : require('@/assets/img/steps/4.jpg'),
          background_m: require('@/assets/img/steps/4-m.jpg')
        },
      ],
      stepsOptions: {
        arrows        : false,
        infinite      : false,
        prevArrow     : '<button type="button" class="slick-prev">&#10094;</button>',
        nextArrow     : '<button type="button" class="slick-next">&#10095;</button>',
        draggable     : false,
        responsive    : [
          {
            breakpoint: 768,
            settings: {
              arrows   : true,
              draggable: true,
              adaptiveHeight: true
            }
          }
        ]
      },
      navOptions: {
        arrows      : false,
        infinite    : false,
        slidesToShow: 4
      }
    }
  },
  methods: {
    goTo(index) {
      if (index === 0) this.$router.push('commande')
      else {
        this.$refs.steps.goTo(index);
        this.current = index;
      }
    },
    sync(event, slick, currentSlide) {
      this.current = currentSlide;
    }
  }
}
</script>

<style scoped lang="scss">
.carousel {
  $this: &;
  position: relative;
  &--steps {
    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }
    .content {
      color: $white;
      background-color: rgba(var(--primary-color), 1);
      padding: rem(24) rem(48);
      min-height: rem(400);
      /deep/ h2 {
        font-weight: normal;
        @include font-size(24);
      }
    }
    &-image {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    &-number {
      color: $white;
      font-family: var(--primary-font-bold);
      @include font-size(96);
      margin-left: rem(24);
    }
  }
  &--nav {
    width: 100%;
    margin: rem(48) auto;
    margin: 0 auto;
    text-align: center;
    #{$this}__item {
      padding: rem(24) rem(8);
      border: rem(1) solid $dark-gray;
      cursor: pointer;
      img {
        width: auto;
        max-height: rem(48);
        margin: 0 auto rem(24);
      }
      &--active {
        border-color: rgba(var(--primary-color), 1);
        p {
          font-weight: bold;
          color: rgba(var(--primary-color), 1);
        }
      }
    }
  }
  &--rtl {
    @include breakpoint('charmander') {
      .carousel--steps-number {
        line-height: 1.3 !important;
      }
    }
  }
  @include breakpoint('charmeleon') {
    &--steps {
      .content {
        padding: rem(24);
      }
    }
  }
  @include breakpoint(924) {
    &--nav {
      #{$this}__item {
        p {
          height: rem(38);
        }
      }
    }
  }
  @include breakpoint('charmander') {
    &--steps {
      .desktop {
        display: none !important;
      }
      .mobile {
        display: block !important;
      }
      &-number {
        line-height: 1;
      }
      .content {
        padding: 0 rem(24) rem(24);
        min-height: initial;
        /deep/ h2 {
          @include font-size(20);
        }
      }
      &-image {
        height: rem(300);
      }
    }
    &--nav {
      display: none;
    }
  }
}
</style>